export default {
  setUser: (state, { user }) => ({
    user
  }),

  setTeams: (state, { teams }) => ({
    teams
  }),

  addUserAndTeam: (state, { user, team }) => ({
    user,
    teams: {
      ...state.teams,
      [team.id]: team
    }
  }),

  setTeamLikers: (state, { teamLikers }) => ({
    teamLikers
  }),

  updateTeamLikers: (state, { teamId, newLikers }) => ({
    teamLikers: {
      ...state.teamLikers,
      [teamId]: newLikers
    }
  }),

  moveTeam: (state, { likerId }) => {
    const newTeams = Object.assign({}, state.teams);
    const liker = state.teams[likerId].members[0];
    liker && newTeams[state.user.teamId].members.push(liker);
    newTeams[likerId].members = [];
    return {
      teams: newTeams
    };
  },

  leftTeam: state => {
    const user = state.user;
    const newTeams = Object.assign({}, state.teams);
    newTeams[user.teamId].members = newTeams[user.teamId].members.filter(
      member => user.id !== member.id
    );
    newTeams[user.id].members.unshift(user);
    return {
      teams: newTeams,
      user: {
        ...user,
        teamId: user.id
      }
    };
  },

  updateUser: (state, { user }) => {
    const newUser = {
      ...state.user,
      ...user
    };

    const newTeams = Object.assign({}, state.teams);
    const members = newTeams[newUser.teamId].members;
    newTeams[newUser.teamId].members = members.map(member => {
      if (member.id === newUser.id) return newUser;
      return member;
    });
    return {
      user: newUser,
      teams: newTeams
    };
  },

  updateTeam: (state, { teamId, changes }) => ({
    teams: {
      ...state.teams,
      [teamId]: {
        ...state.teams[teamId],
        ...changes
      }
    }
  }),

  updateAccessToken: (state, { accessToken }) => ({
    accessToken: accessToken
  }),

  showUpdateProfileDialog: () => ({
    updateProfileDialogVisible: true
  }),

  showCreateProfileDialog: () => ({
    createProfileDialogVisible: true
  }),

  hideProfileDialog: () => ({
    updateProfileDialogVisible: false,
    createProfileDialogVisible: false
  }),

  showUpdateTeamDialog: () => ({
    updateTeamDialogVisible: true
  }),

  hideUpdateTeamDialog: () => ({
    updateTeamDialogVisible: false
  }),

  showLoginDialog: () => ({
    loginDialogVisible: true
  }),

  hideLoginDialog: () => ({
    loginDialogVisible: false
  }),

  showNotification: (state, { message, type }) => ({
    notification: {
      visible: true,
      message,
      type: type || "info"
    }
  }),

  hideNotification: () => ({
    notification: {
      visible: false,
      message: "",
      type: "info"
    }
  })
};
